import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { CommandCode } from "../../utils/network/generated/protoTypes";
export var mapOutskirtIdToImprovementInfo = new Map([
    [
        IdOutskirtBuildings.Library,
        {
            command: CommandCode.BuyLibraryImprovement,
        },
    ],
    [
        IdOutskirtBuildings.Market,
        {
            command: CommandCode.BuyMarketImprovement,
        },
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/improvement/mapOutskirtIdToImprovementInfo.ts
// module id = 1896
// module chunks = 3